import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import facility from "./facilities";
import document from "./documents";

export default combineReducers({
  auth,
  message,
  facility,
  document,
});
